/**
 * propertyType
 * proposedPropertyType
 */
export const selectOptionsPipelineType = [
  "Borrower Portal Scenarios",
  "Scenario",
  "Underwriting",
  "Commercial",
];
